import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Component_VariableSelector.scss';
import { Dialog_VariableEditor } from '../Dialogs/index.js';
import { ICONS } from '@app/styles';
import { DropDown_Variable } from '../../../shared-components/index.js';
import { ConfigKeyFE_SourceTagId, ModuleFE_Variable } from '../../../../_entity.js';
export class Component_VariableSelector extends ComponentSync {
    __onVariableUpdated() {
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state.selectedVariableId = nextProps.selectedVariableId;
        state.queryFilter = nextProps.queryFilter;
        return state;
    }
    getVariable = () => {
        return ModuleFE_Variable.cache.unique(this.state.selectedVariableId);
    };
    renderEditButton() {
        const disabled = !this.props.selectedVariableId;
        const variable = this.getVariable();
        const sourceTag = ConfigKeyFE_SourceTagId.get();
        const tagId = variable?.tagIds.find(i => i.key === sourceTag)?.value[0];
        return _jsx(Button, { disabled: disabled, className: 'edit-button', onClick: () => {
                Dialog_VariableEditor.show(tagId, variable);
            }, children: _jsx(ICONS.edit.component, {}) });
    }
    renderTail = () => {
        const renderer = this.props.tailRenderer;
        if (!renderer)
            return '';
        return typeof renderer === 'function' ? renderer() : renderer;
    };
    render() {
        if (this.props.allowSelection)
            return _jsxs(LL_H_C, { className: 'variable-selector', children: [_jsx(DropDown_Variable, { queryFilter: this.props.queryFilter, onSelected: this.props.onVariableSelected, selected: this.state.selectedVariableId, sortBy: ['name'], placeholder: this.props.placeholder }), this.renderEditButton(), this.renderTail()] });
        return _jsxs(LL_H_C, { className: 'variable-selector', children: [_jsx("div", { className: 'variable-name', children: this.getVariable()?.name }), this.renderEditButton(), this.renderTail()] });
    }
}
//# sourceMappingURL=Component_VariableSelector.js.map